import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border: 1.5px solid #d3aa3b;
`;
